import styled from 'styled-components';

import { deviceMaxWidth, style } from 'utils/constants/style';

export const PrivateContentPlaceholderWrap = styled.div`
  width: 550px;
  height: 300px;
  background: white;
  border-radius: 8px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span {
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 150%;
    text-align: center;
    letter-spacing: 0.01em;
    color: ${style.mainGray.SuvaGrey};
  }

  @media only screen and (${deviceMaxWidth.sm}) {
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
  }
`;
